<template>
  <div class="u-wrap">
    <div class="card">
      <van-cell center title="事件类型" :value="object.sjlx_dictText" />
      <van-cell center title="小区" :value="object.xq_dictText" />
      <van-cell center title="楼栋" :value="object.ld_dictText" />
      <van-cell center title="单元" :value="object.dy" />
      <van-cell center title="房屋" :value="object.fw_dictText" />

      <van-cell title="报事内容" value="" :border="false" />
      <textarea placeholder="请填写详细内容" class="xxnr" v-model="object.bsnr" readonly></textarea>

      <div class="imgList" v-if="object.zp">
        <div class="title">图片</div>
        <div class="pre-item" v-for="(img, index) in object.zp.split(',')" :key="index">
          <img class="pre-item-image" :src="img" @click="preImage(index, object.zp.split(','))" />
        </div>
      </div>
      <div class="video-p" v-if="object.sp">
        <div class="title">视频</div>
        <div v-for="(item, i) in object.sp.split(',')" :key="i" style="position: relative; display: inline-block">
          <video ref="video" :id="'myVideos' + i" class="video-js vjs-default-skin vjs-big-play-centered mt10">
            <source :src="item" type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="time">时间：{{ object.createTime }}</div>
    </div>

    <div v-if="object.lcList&&object.lcList.length>0" class="card" style="padding: 12px">
      <time-wyfw :list="object.lcList"></time-wyfw>
    </div>

    <div class="b-btn">
      <button class="b-button" :disabled="false" @click="clickBack">返回</button>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import timeWyfw from '@/views/common/time-wyfw.vue'
import { ImagePreview } from 'vant'
export default {
  components: {
    timeWyfw,
  },
  data() {
    return {
      object: {},
      listHelp: [],
      id: '',
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getData()
  },
  mounted() {},
  computed: {},
  methods: {
    getData() {
      let params = { id: this.id }
      getAction('/zhshj/hmfwbsbx/gzh/page', params).then((res) => {
        if (res.success) {
          let list = res.result.records
          this.object = list[0]
        }
      })
    },
    clickBack() {
      this.$router.go(-1)
    },
    preImage(index, imgList) {
      ImagePreview({
        images: imgList,
        startPosition: index,
      })
    },
    initVideo() {
      let elementList = document.querySelectorAll('.video-js')
      this.element = elementList.length //videojs 数量赋值
      for (let index = 0; index < elementList.length; index++) {
        let id = elementList[index].getAttribute('id')
        this.$video(
          id,
          {
            autoplay: false, //自动播放
            //   muted:false, // 是否静音,
            controls: true, //控制条
            //   techOrder: ['html5','flash'],//设置flash播放
            language: 'en', // 初始化语言
            preload: 'auto', // 预加载
            width: '300',
            height: '400',
            // 倍速播放
            playbackRates: [0.5, 1, 1.5, 2],
          },
          function () {
            this.volume(0)
            //这个地方很重要,一旦你的muted 不起作用 ,就一定要在设置当前的视频回调中设置声音为0
            //this.play(); //这个地方也一样 ,此方法this.play()==autoplay  是有相同的效果
            this.one('playing', function () {
              // 监听播放
              console.log('成功初始化视频')
            })

            this.one('error', function (error) {
              // 监听错误
              console.error('监听异常', error)
            })
          }
        )
      }
    },
  },
  beforeDestroy() {
    if (this.object.sp) {
      let videoList = this.object.sp.split(',')
      for (let index = 0; index < videoList; index++) {
        this.$video(`myVideos${index}`).dispose()
      }
    }
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  box-sizing: border-box;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  // flex-wrap: wrap;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 12px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;
  margin: 20px 0;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
.imgList {
  border-top: 1px solid #dedede;
  margin: 0 12px;

  .pre-item-image {
    width: 80px;
    height: 80px;
  }
}

.audio-list {
  border-top: 1px solid #dedede;
  margin: 0 12px;
}

.time {
  color: #999999;
  font-size: 13px;
  padding: 12px;
}
.title {
  width: 100%;
  line-height: 38px;
}

.video-p {
  border-top: 1px solid #dedede;
  margin: 0 12px;
}

.video-class {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
